import { MealCountDto, ProgramType, MealType, ReceivedMeals, ServingLine } from '@/models';
import { UserInfo } from '@/store';
import { MealCountDtoViewModel } from '@/view-models';
import { Guid } from 'guid-typescript';
import moment from "moment";

let user = new UserInfo('Test User', 1, 'a', 'Test', 'User');

let date = moment.utc().format();
let receive = new ReceivedMeals('2020-02-10', 10, 100, 11, 1, 1, 'Test', 'User', date, date);
let serve = new ServingLine(
    Guid.create().toString(),
    1,
    2,
    3,
    4,
    1,
    1,
    1,
    1,
    0,
    true,
    1,
    'Test',
    'User',
    date,
    date);

let mealCount = new MealCountDto(
    Guid.create().toString(),
    8,
    ProgramType.SFSP,
    MealType[MealType.Lunch],
    '2020-02-14',
    date,
    false,
    0,
    receive,
    [ serve ]);

let viewModel = new MealCountDtoViewModel(mealCount);

export let data = {
  user: user,
  vm: viewModel,
  mealCount: mealCount
};
